import { browserHistory } from 'react-router'
import { connect } from 'react-redux'

import {
  convertToRaw,
} from 'draft-js'
import draftToHtml from 'draftjs-to-html'

import {
  getEmails,
} from 'reduxpath/ducks/Email/List'

import {
  updateEmail,
  setLoadState,
  setData,
} from 'reduxpath/ducks/Email/Edit'

import Edit from './units'

function mapStateToProps(state) {
  return {
    data: state.EmailEdit.data,
    template: state.EmailEdit.data.template,
    editorState: state.EmailEdit.data.editor,
    concateTemplate: state.EmailEdit.data.content,
  }
}

const mapDispatchToProps = dispatch => ({
  handleEditorChange(data) {
    return (editor) => {
      const editorStateHTML = draftToHtml(
        convertToRaw(editor.getCurrentContent()),
      )
      const content = data.content
      const lengthString = "<div class='content'>".length
      const contentOnly = data.content.substring(
        data.content.lastIndexOf(
          '<div class="content">',
        ) + lengthString,
        data.content.lastIndexOf('</div>'))
      const concateTemplate = content.replace(
        contentOnly,
        editorStateHTML,
      )
      const params = {
        data: {
          ...data,
          editor,
          content: concateTemplate,
        },
      }
      dispatch(setData(params))
    }
  },
  handleFormChange(data) {
    return (e) => {
      const params = {
        data: {
          id: data.id,
          subject: e.target.name === 'subject'
            ? e.target.value
            : data.subject,
          category: e.target.name === 'category'
            ? e.target.value
            : data.category,
          group: e.target.name === 'group'
            ? e.target.value
            : data.group,
          type: e.target.name === 'type'
            ? e.target.value
            : data.type,
          template: data.template,
          content: data.content,
          editor: data.editor,
        },
      }
      dispatch(setData(params))
    }
  },

  handleEmailTemplateChange(data) {
    return (e) => {
      const params = {
        data: {
          ...data,
          template: e.target.value,
          content: data.content,
        },
      }
      dispatch(setData(params))
    }
  },

  handleMailChange(data) {
    return (e) => {
      const params = {
        ...data,
        ...{ content: e.target.innerHTML },
      }
      // console.log(e.target.innerHTML)
      dispatch(setData(params))
    }
  },

  handleCancel() {
    browserHistory.push('/emails')
  },

  editEmail(data) {
    return (e) => {
      e.preventDefault()
      const content = data.content
        .replace('<pre><a href="{{link}}"', '<a href="{{link}}" style="color: #fff;display:inline-block;margin: 0 auto;background: #45ada8;text-align:center;padding:8px  10px;border-radius: 4px !important;margin-bottom: 0;font-weight: bolder;"')
        .replace('</pre>', '')
        .replace(/<p>/gi, '<p style="margin:30px 0;">')
        .replace('color: rgb(0,0,0);', 'color: #fff;')
        .replace('<ol>', '<ol style="width:100%;padding:0;display:table;">')
        .replace(/<li>/gi, '<li style="float:left;width:50%;list-style:none;margin:0 !important;">')
      dispatch(setLoadState(true))
      const updatedEmail = {
        id: data.id,
        subject: data.subject,
        category: data.category,
        group: data.group,
        type: data.type,
        content,
      }

      dispatch(updateEmail(updatedEmail, data.id, () => {
        dispatch(setLoadState(false))
        browserHistory.push('/emails')
      }))
    }
  },
})


export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Edit)
